// WhatWeProvide.jsx
import React from "react";
import { Container, Grid, Typography, Box, Card, CardContent, Button } from "@mui/material";
import { Link } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LightbulbIcon from "@mui/icons-material/Lightbulb";

const WhatWeProvide = () => {
  const services = [
    {
      iconBg: "/images/homepage/icon.png",
      iconFg: <AttachMoneyIcon sx={{ fontSize: "40px", color: "white" }} />,
      title: "Global Drug Price Comparisons",
      tagline: "See how U.S. prescription drug prices compare to the rest of the world.",
      description: "Explore up-to-date comparisons of prescription drug prices across the U.S. and other countries. Our centralized platform highlights real cost differences to help consumers, journalists, and policymakers understand the global pricing landscape.",
      buttonText: "Compare Prices",
      buttonLink: "scroll-to-top"
    },
    {
      iconBg: "/images/homepage/icon.png",
      iconFg: <AccountBalanceIcon sx={{ fontSize: "40px", color: "white" }} />,
      title: "Advocacy & Action",
      tagline: "Make your voice heard.",
      description: "Enter your zip code to identify  and contact your elected representatives using our pre-filled template. By sharing real price comparisons with policymakers, you can help raise awareness about prescription drug pricing disparities and encourage meaningful reform.",
      buttonText: "Take Action",
      buttonLink: "/contact-congressman"
    },
    {
      iconBg: "/images/homepage/icon.png",
      iconFg: <LightbulbIcon sx={{ fontSize: "40px", color: "white" }} />,
      title: "Research & Insight",
      tagline: "Understand the 'why' behind the prices.",
      description: "Browse curated articles, reports, and original blog posts that investigate the economic, political, and regulatory forces making U.S. medications the most expensive in the world.",
      buttonText: "Read Research",
      buttonLink: "/healthcare"
    }
  ];

  return (
    <Box
      className="what_we_provide_section"
      sx={{
        py: 10,
        backgroundColor: "#ffffff"
      }}
    >
      <Container>
        <Box textAlign="center" mb={8}>
          <Typography
            variant="h2"
            className="heading_two"
            sx={{
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
              fontWeight: 700,
              color: "#1a1a1a",
              mb: 2
            }}
          >
            What We Provide
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                elevation={0}
                sx={{
                  backgroundColor: "#f5f5f5",
                  height: "100%",
                  borderRadius: 4,
                  p: 4,
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                }}
              >
                <CardContent sx={{ p: 0, "&:last-child": { pb: 0 }, flexGrow: 1, display: "flex", flexDirection: "column" }}>
                  {/* Icon */}
                  <Box
                    sx={{
                      width: 80,
                      height: 80,
                      borderRadius: "12px",
                      position: "relative",
                      mb: 3,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    {/* Background icon */}
                    <img
                      src={service.iconBg}
                      alt="icon background"
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                      }}
                    />
                    {/* Foreground icon */}
                    <Box
                      sx={{
                        position: "absolute",
                        zIndex: 1,
                        display: "flex"
                      }}
                    >
                      {typeof service.iconFg === "string" && service.iconFg.startsWith("/") ? (
                        <img
                          src={service.iconFg}
                          alt="icon"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain"
                          }}
                        />
                      ) : (
                        service.iconFg
                      )}
                    </Box>
                  </Box>

                  {/* Title */}
                  <Typography
                    sx={{
                      fontWeight: 700,
                      color: "#1a1a1a",
                      mb: 1.5,
                      fontSize: "24px"
                    }}
                  >
                    {service.title}
                  </Typography>

                  {/* Tagline */}
                  <Typography
                    sx={{
                      color: "#43C5B9",
                      fontWeight: 400,
                      mb: 2.5,
                      fontSize: "22px"
                    }}
                  >
                    {service.tagline}
                  </Typography>

                  {/* Description */}
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#4a4a4a",
                      lineHeight: 1.7,
                      mb: 4,
                      flexGrow: 1,
                      fontSize: "18px"
                    }}
                  >
                    {service.description}
                  </Typography>

                  {/* Button */}
                  <Button
                    variant="contained"
                    endIcon={<ArrowForwardIcon />}
                    component={service.buttonLink !== "scroll-to-top" ? Link : "button"}
                    to={service.buttonLink !== "scroll-to-top" ? service.buttonLink : undefined}
                    onClick={(e) => {
                      if (service.buttonLink === "scroll-to-top") {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                    sx={{
                      backgroundColor: "#43C5B9",
                      color: "white",
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "1rem",
                      borderRadius: 50,
                      alignSelf: "flex-start",
                    }}
                  >
                    {service.buttonText}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhatWeProvide;